import { Page, PathButton } from "shared/react";
import { REWARD_MAX, type RewardType } from "shared/schema";
import { RewardGrid } from "../reward/RewardGrid.js";
import { CreatorCondition } from "./CreatorCondition.js";
import { useCreatorContext } from "./CreatorContext.js";
import { EntityHeader } from "../entity/EntityHeader.js";

function RewardsCreatedPage({ type }: { type: RewardType }): React.ReactElement {
	const creator = useCreatorContext();
	return (
		<Page title={`Created ${type}s`} path={`./${type}s`}>
			<EntityHeader entity={creator}>
				<h1>{`Created ${type}s`}</h1>
			</EntityHeader>
			<CreatorCondition creator={creator}>
				<section>
					<PathButton path={`./new`}>{`Create ${type}`}</PathButton>
				</section>
			</CreatorCondition>
			<RewardGrid
				type={type}
				query={{
					creator,
					type,
					$order: "!created",
					$limit: REWARD_MAX,
				}}
			/>
		</Page>
	);
}

export function BadgesCreatedPage(): React.ReactElement {
	return <RewardsCreatedPage type="badge" />;
}

export function BackgroundsCreatedPage(): React.ReactElement {
	return <RewardsCreatedPage type="background" />;
}

export function ReactionsCreatedPage(): React.ReactElement {
	return <RewardsCreatedPage type="reaction" />;
}
